import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 15.029",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Component_37_3",
		"data-name": "Component 37 \\u2013 3",
		transform: "translate(0 0.5)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Rectangle_1487",
			"data-name": "Rectangle 1487",
			transform: "translate(0 5.529)",
			fill: "none",
			stroke: "#fff",
			strokeLinejoin: "round",
			strokeWidth: 1,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 9,
				stroke: "none"
			}), /* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 13,
				height: 8,
				fill: "none"
			})]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_800",
			"data-name": "Path 800",
			d: "M10.5,8.888V6.271A3.485,3.485,0,0,1,14.165,3,3.485,3.485,0,0,1,17.83,6.271V8.888",
			transform: "translate(-7.165 -3)",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		})]
	})
});
export default SvgLocked;
